import { EventQueueRowData, UnitQueueRowData } from '../../../socket/stream-types';
import { observer } from 'mobx-react-lite';
import { BaseQueueCell } from '../base-queue-cell';
import { getEventQueueRowData } from '../../utils/get-event-queue-row-data';
import { PriorityBox } from '../../../common/components/fr-queues/priority-box';
import { colors } from '../../../colors/colors';

type ColorState = 'solid' | 'flashing' | 'none';

export const PriorityCell = observer(function PriorityCell({
    data,
}: {
    data: EventQueueRowData | UnitQueueRowData;
}): React.ReactElement {
    let colorState: ColorState = 'none';
    const dataToUse = getEventQueueRowData(data);
    if (!dataToUse) {
        return <span />;
    }
    const isAssigned =
        dataToUse.assignedUnits &&
        dataToUse.assignedUnits.filter((unit) => !unit.isHeld).length > 0;
    if (dataToUse.maxUnassignedTimeReached && !isAssigned) {
        colorState = 'flashing';
    } else if (dataToUse.isPriority1) {
        colorState = 'solid';
    }

    const cell = (
        <BaseQueueCell
            alignment="CENTER"
            data-testid="PRIORITY"
            backgroundColor={colorState === 'solid' ? colors.queuePriority : undefined}
        >
            {dataToUse.priority}
        </BaseQueueCell>
    );

    return <PriorityBox isFlashing={colorState === 'flashing'}>{cell}</PriorityBox>;
});
